import React, { useMemo } from "react";
import { Sigma } from "lucide-react";
import MasterDataCrudPage from "./MasterDataCrudPage";
import apiService from "../../services/api";

const StrategyTypeManagement = () => {
  const api = useMemo(
    () => ({
      list: (params) => apiService.strategyTypes.list(params),
      create: (data) => apiService.strategyTypes.create(data),
      update: (id, data) => apiService.strategyTypes.update(id, data),
      delete: (id) => apiService.strategyTypes.delete(id),
    }),
    [],
  );

  return (
    <MasterDataCrudPage
      title="策略类型"
      subtitle="维护策略类型主数据；新建账号配置时需选择已启用的策略类型。"
      singularName="策略类型"
      api={api}
      TitleIcon={Sigma}
    />
  );
};

export default StrategyTypeManagement;
